import { TIPTAP_COLLAPSIBLE_ITEM_TYPE, TIPTAP_COLLAPSIBLE_ITEM_TITLE_TYPE, TIPTAP_COLLAPSIBLE_ITEM_BODY_TYPE, EMOJI_TYPE } from 'ricos-content';
import { Node_Type } from 'ricos-types';
import { DEFAULTS } from '../defaults.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const defaultCollapsibleItem = [
  {
    type: TIPTAP_COLLAPSIBLE_ITEM_TYPE,
    content: [
      {
        type: TIPTAP_COLLAPSIBLE_ITEM_TITLE_TYPE,
        content: [
          {
            type: Node_Type.PARAGRAPH,
            content: []
          }
        ]
      },
      {
        type: TIPTAP_COLLAPSIBLE_ITEM_BODY_TYPE,
        content: [
          {
            type: Node_Type.PARAGRAPH,
            content: []
          }
        ]
      }
    ]
  }
];
const defaultCollapsibleList = __spreadValues({
  content: defaultCollapsibleItem,
  containerData: { alignment: "CENTER", textWrap: true }
}, DEFAULTS.config);
const supportedPluginTypes = [
  `${Node_Type.AUDIO}.audio`,
  `${Node_Type.AUDIO}.soundCloud`,
  `${Node_Type.AUDIO}.spotify`,
  Node_Type.FILE,
  Node_Type.IMAGE,
  `${Node_Type.VIDEO}.video`,
  `${Node_Type.VIDEO}.youTube`,
  Node_Type.GIF,
  Node_Type.DIVIDER,
  EMOJI_TYPE,
  Node_Type.CODE_BLOCK,
  `${Node_Type.APP_EMBED}.event`,
  `${Node_Type.APP_EMBED}.booking`,
  `${Node_Type.APP_EMBED}.product`,
  `${Node_Type.LINK_PREVIEW}.instagram`,
  `${Node_Type.LINK_PREVIEW}.twitter`,
  `${Node_Type.LINK_PREVIEW}.pinterest`,
  `${Node_Type.LINK_PREVIEW}.facebook`,
  `${Node_Type.LINK_PREVIEW}.tiktok`
];

export { defaultCollapsibleItem, defaultCollapsibleList, supportedPluginTypes };
//# sourceMappingURL=defaults.js.map
